export enum HardwareType {
  Node = 0,
  CPU = 1,
  Memory = 2,
  Storage = 3,
  Network = 4,
  GPU = 5,
}
